"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ProductPassengerTyres_vue_1 = __importDefault(require("../../pages/productPassengerTyres/ProductPassengerTyres.vue"));
const ProductTruckTyres_vue_1 = __importDefault(require("../../pages/productTruckTyres/ProductTruckTyres.vue"));
const ProductAgriculturalAndIndustrialTyres_vue_1 = __importDefault(require("../../pages/productAgriculturalAndIndustrialTyres/ProductAgriculturalAndIndustrialTyres.vue"));
const ProductForkliftTyres_vue_1 = __importDefault(require("../../pages/productForkliftTyres/ProductForkliftTyres.vue"));
const ProductMotorcycleTyres_vue_1 = __importDefault(require("../../pages/productMotorcycleTyres/ProductMotorcycleTyres.vue"));
const ProductRimsByCar_vue_1 = __importDefault(require("../../pages/productRimsByCar/ProductRimsByCar.vue"));
const ProductTubesAndTapes_vue_1 = __importDefault(require("../../pages/productTubesAndTapes/ProductTubesAndTapes.vue"));
const ProductAccessories_vue_1 = __importDefault(require("../../pages/productAccesories/ProductAccessories.vue"));
const ProductRimsBySize_vue_1 = __importDefault(require("../../pages/productRimsBySize/ProductRimsBySize.vue"));
const ProductBySku_vue_1 = __importDefault(require("../../pages/productBySku/ProductBySku.vue"));
const Checkout_vue_1 = __importDefault(require("../../pages/checkout/Checkout.vue"));
const SuccessOrder_vue_1 = __importDefault(require("../../pages/successOrder/SuccessOrder.vue"));
const Quote_vue_1 = __importDefault(require("../../pages/quote/Quote.vue"));
const ProductSpareWheel_vue_1 = __importDefault(require("../../pages/productSpareWheel/ProductSpareWheel.vue"));
exports.default = [
    {
        name: 'shop_tube_and_tape_product_search',
        path: '/shop/tube-and-tape-product-search',
        component: ProductTubesAndTapes_vue_1.default,
        meta: { requiresAuth: true, title: 'Tube and Tape Product Search' }
    },
    {
        name: 'shop_accessories_search',
        path: '/shop/accessories-search',
        component: ProductAccessories_vue_1.default,
        meta: { requiresAuth: true, title: 'Accessories Search' }
    },
    {
        name: 'shop_sku_search',
        path: '/shop/sku-search',
        component: ProductBySku_vue_1.default,
        meta: { requiresAuth: true, title: 'SKU Search' }
    },
    {
        name: 'shop_rim_search',
        path: '/shop/rim-search',
        component: ProductRimsBySize_vue_1.default,
        meta: { requiresAuth: true, title: 'Rims Search' }
    },
    {
        name: 'shop_spare_wheel',
        path: '/shop/spare-wheels',
        component: ProductSpareWheel_vue_1.default,
        meta: { requiresAuth: true, title: 'Spare Wheels Search' }
    },
    {
        name: 'shop_passenger_tyres',
        path: '/shop/passenger-tyres',
        component: ProductPassengerTyres_vue_1.default,
        meta: { requiresAuth: true, title: 'Passenger Tyres Search' }
    },
    {
        name: 'shop_truck_tyres',
        path: '/shop/truck-tyres',
        component: ProductTruckTyres_vue_1.default,
        meta: { requiresAuth: true, title: 'Truck Tyres Search' }
    },
    {
        name: 'shop_agricultural_and_industrial_tyres',
        path: '/shop/agricultural-and-industrial-tyres',
        component: ProductAgriculturalAndIndustrialTyres_vue_1.default,
        meta: { requiresAuth: true, title: 'Agricultural And Industrial Tyres Search' }
    },
    {
        name: 'shop_forklift_tyres',
        path: '/shop/forklift-tyres',
        component: ProductForkliftTyres_vue_1.default,
        meta: { requiresAuth: true, title: 'Forklift Tyres Search' }
    },
    {
        name: 'shop_motorcycle_tyres',
        path: '/shop/motorcycle-tyres',
        component: ProductMotorcycleTyres_vue_1.default,
        meta: { requiresAuth: true, title: 'Motorcycle Tyres Search' }
    },
    {
        name: 'shop_products_get_filter_values',
        path: '/api/products/get-filter-values',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_products_get_filter_values_by_name_alias',
        path: '/api/products/get-filter-values-by-name-alias',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_products',
        path: '/api/products',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_rim_search_by_car',
        path: '/shop/rim-search-by-car',
        component: ProductRimsByCar_vue_1.default,
        meta: { requiresAuth: true, title: 'Rim Search By Car' }
    },
    {
        name: 'shop_products_stock_details',
        path: '/api/products/:id/get-stock-details',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_products_supplier_delivery_days',
        path: '/api/products/:id/get-supplier-delivery-days',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_carts',
        path: '/api/carts/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_carts_add_product',
        path: '/api/carts/:id/add-product',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_carts_update_product_quantity',
        path: '/api/carts/:id/update-product-quantity',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_carts_remove_product',
        path: '/api/carts/:id/remove-product',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_carts_empty',
        path: '/api/carts/:id/empty',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_carts_refresh_stock_infos',
        path: '/api/carts/:id/refresh-stock-infos',
        redirect: '',
        meta: { requiresAuth: true }
    },
    //CHECKOUT
    {
        name: 'shop_checkout_shipping_modes',
        path: '/api/checkout/shipping-modes/:id',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_checkout_shipping_addresses',
        path: '/api/checkout/shipping-addresses/:id',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_checkout_payment_modes',
        path: '/api/checkout/payment-modes/:id',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_checkout_extra_fees',
        path: '/api/checkout/extra-fees/:id',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_checkout_create_order',
        path: '/api/orders',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'api_order',
        path: '/api/orders/:id',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_products_alcar_rims',
        path: '/api/products/get-alcar-rims/:alcarModelCode',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_products_get_valves',
        path: '/api/products/get-valves',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_products_tread_codes',
        path: '/api/products/get-tread-codes/:treadCode',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_products_brand_price_categories',
        path: '/api/products/get-brand-price-categories',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_products_price_check',
        path: '/api/products/price-check',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_products_stock_check',
        path: '/api/products/stock-check',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_checkout',
        path: '/shop/checkout',
        component: Checkout_vue_1.default,
        meta: { requiresAuth: true, title: 'Checkout' }
    },
    {
        name: 'shop_success_order',
        path: '/shop/success-order/:id',
        component: SuccessOrder_vue_1.default,
        meta: { requiresAuth: true, title: 'Success Order' }
    },
    {
        name: 'shop_discounts',
        path: '/api/discounts/:id',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_quote',
        path: '/shop/quote',
        component: Quote_vue_1.default,
        meta: { requiresAuth: true, title: 'Quote', hasDefaultLayout: false }
    },
    {
        name: 'shop_product_filter_values_api',
        path: '/api/product-filter-values',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_homologations_api',
        path: '/api/homologations',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'shop_get_country_codes_api',
        path: '/api/get-country-codes',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        // DEV-4209 refactor során került ide, korábban a store-ban voltak felsorolva az url-ek
        // mivel csak ez az egy url van, így nem csináltam neki külön route fájlt
        name: 'alcar_api',
        path: '/user-cars/alcar-api',
        component: ProductRimsByCar_vue_1.default,
        meta: { requiresAuth: true }
    }
];
